import React from 'react'
import "./skill1.css"
const Skill1 = () => {
  return (
    <div className="haunt">
        <pre className="pa2">
    <p>       
    Technical Skills 💻 :</p> 

    🚀Frontend: HTML, CSS, JavaScript, React  <br/>
    🛠Backend: Node.js, Express.js   <br/>
    🗄Database: MongoDB  <br/>
    ⚙️Tools: Git, GitHub, VS Code  <br/>
    📚Concepts: REST APIs, JWT Auth, Async Programming
        </pre>
    </div>
  )
}

export default Skill1
